import {
	DOLLAR_DECIMALS,
	DOLLAR_DELTA,
	DOLLAR_INPUT_TYPE,
	DOLLAR_MAX,
	DOLLAR_MIN,
	DOLLAR_PER_DAY_INPUT_TYPE,
	DOLLAR_PER_UNIT_INPUT_TYPE,
	HIGHEST_NUMBER,
	UNIT_INPUT_TYPE,
} from "@/Common/constants/InputData";
import { TInputData } from "@/Layouts/types/InputComponents/InputFormExtension";
import { CSSProperties } from "react";

const dollarInputSx = { width: "95px" };

export interface IPvrTypeOption {
	value: string;
	label: string;
	spiffType: "SALES" | "TRADES";
}

export enum TPvrType {
	FRONT_END_PVR = "Front End PVR",
	INVENTORY_AGE = "Inventory Age",
	TRADES_PVR = "Trades PVR",
	TRADES_ACV = "Trades ACV",
}

export const PvrTypeOptions: IPvrTypeOption[] = [
	// Sales
	{ value: TPvrType.FRONT_END_PVR, label: TPvrType.FRONT_END_PVR, spiffType: "SALES" },
	{ value: TPvrType.INVENTORY_AGE, label: "Inventory Age (Days)", spiffType: "SALES" },
	// Trades
	{ value: TPvrType.TRADES_PVR, label: TPvrType.TRADES_PVR, spiffType: "TRADES" },
	{ value: TPvrType.TRADES_ACV, label: TPvrType.TRADES_ACV, spiffType: "TRADES" },
];

export const PvrTypeInputConfig: Partial<
	Record<
		TPvrType,
		{
			columnInput: TInputData;
			columnInputSx: CSSProperties;
			bonusInput: TInputData[];
			bonusInputSx: CSSProperties;
		}
	>
> = {
	[TPvrType.FRONT_END_PVR]: {
		columnInput: {
			type: DOLLAR_INPUT_TYPE,
			min: -HIGHEST_NUMBER,
			max: HIGHEST_NUMBER,
			delta: DOLLAR_DELTA,
			decimals: DOLLAR_DECIMALS,
			decimalsEditable: true,
		},
		columnInputSx: dollarInputSx,
		bonusInput: [
			{
				type: DOLLAR_INPUT_TYPE,
				min: DOLLAR_MIN,
				max: DOLLAR_MAX,
				decimalsEditable: false,
				decimals: DOLLAR_DECIMALS,
			},
			{
				type: DOLLAR_PER_UNIT_INPUT_TYPE,
				min: DOLLAR_MIN,
				max: DOLLAR_MAX,
				decimalsEditable: false,
				decimals: DOLLAR_DECIMALS,
			},
		],
		bonusInputSx: dollarInputSx,
	},
	[TPvrType.INVENTORY_AGE]: {
		columnInput: {
			type: UNIT_INPUT_TYPE,
			min: -HIGHEST_NUMBER,
			max: HIGHEST_NUMBER,
			delta: DOLLAR_DELTA,
			decimals: DOLLAR_DECIMALS,
			decimalsEditable: true,
		},
		columnInputSx: dollarInputSx,
		bonusInput: [
			{
				type: DOLLAR_INPUT_TYPE,
				min: DOLLAR_MIN,
				max: DOLLAR_MAX,
				decimalsEditable: false,
				decimals: DOLLAR_DECIMALS,
			},
			{
				type: DOLLAR_PER_UNIT_INPUT_TYPE,
				min: DOLLAR_MIN,
				max: DOLLAR_MAX,
				decimalsEditable: false,
				decimals: DOLLAR_DECIMALS,
			},
			{
				type: DOLLAR_PER_DAY_INPUT_TYPE,
				min: DOLLAR_MIN,
				max: DOLLAR_MAX,
				decimalsEditable: false,
				decimals: DOLLAR_DECIMALS,
			},
		],
		bonusInputSx: dollarInputSx,
	},
	[TPvrType.TRADES_ACV]: {
		columnInput: {
			type: DOLLAR_INPUT_TYPE,
			min: 0,
			max: HIGHEST_NUMBER,
			delta: DOLLAR_DELTA,
			decimals: DOLLAR_DECIMALS,
			decimalsEditable: true,
		},
		columnInputSx: dollarInputSx,
		bonusInput: [
			{
				type: DOLLAR_INPUT_TYPE,
				min: DOLLAR_MIN,
				max: DOLLAR_MAX,
				decimalsEditable: false,
				decimals: DOLLAR_DECIMALS,
			},
			{
				type: DOLLAR_PER_UNIT_INPUT_TYPE,
				min: DOLLAR_MIN,
				max: DOLLAR_MAX,
				decimalsEditable: false,
				decimals: DOLLAR_DECIMALS,
			},
		],
		bonusInputSx: dollarInputSx,
	},
};
